import { useCallback, useEffect, useState } from "react";

const NAV_OPEN_STORAGE_KEY = 'layout_nav_open'
const MOBILE_NAV_MEDIA_QUERY = '(max-width: 1024px)'

const getSavedDesktopNavState = () => {
    const savedValue = localStorage.getItem(NAV_OPEN_STORAGE_KEY)
    return savedValue === null || savedValue === 'true'
}

export const useLayoutNavigation = () => {
    const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_NAV_MEDIA_QUERY).matches)
    const [desktopNavOpen, setDesktopNavOpen] = useState(getSavedDesktopNavState)
    const [mobileNavOpen, setMobileNavOpen] = useState(false)

    useEffect(() => {
        const mediaQuery = window.matchMedia(MOBILE_NAV_MEDIA_QUERY)
        const onMediaChange = (event: MediaQueryListEvent) => {
            setIsMobile(event.matches)
            setMobileNavOpen(false)
        }

        mediaQuery.addEventListener('change', onMediaChange)
        return () => mediaQuery.removeEventListener('change', onMediaChange)
    }, [])

    useEffect(() => {
        localStorage.setItem(NAV_OPEN_STORAGE_KEY, String(desktopNavOpen))
    }, [desktopNavOpen])

    const toggleNav = useCallback(() => {
        if(isMobile){
            setMobileNavOpen(open => !open)
            return
        }

        setDesktopNavOpen(open => !open)
    }, [isMobile])

    const closeMobileNav = useCallback(() => {
        if(isMobile){
            setMobileNavOpen(false)
        }
    }, [isMobile])

    return {
        isMobile,
        navOpen: isMobile ? mobileNavOpen : desktopNavOpen,
        toggleNav,
        closeMobileNav,
    }
}
